import { isEmpty } from 'lodash';
import type { CategoryWebLink } from '../types';
import { cmsConfigTransformer } from './utils/cmsConfigTransformer';
import { configTransformer } from './utils/configTransformer';

export const cmsConfigurationTransformer = (categoriesCmsConfig: CategoryWebLink | undefined) => {
    if (isEmpty(categoriesCmsConfig)) {
        return {};
    }

    return configTransformer(cmsConfigTransformer(categoriesCmsConfig));
};
